<template>
  <div v-if="show" class="main-table">
    <ul class="responsive-table">
      <li class="table-header">
        <div v-if="!CheckUserPermission([7])" class="col col-3">User</div>
        <div class="col col-1">#Id</div>
        <div class="col col-3">Name</div>
        <div class="col col-4">Email</div>
        <div class="col col-4">Country</div>
        <div class="col col-2">Reason</div>
        <div class="col col-2">Scheduled On</div>
        <div class="col col-3">Time Left</div>
      </li>

      <li
        class="table-row"
        v-for="client in nextCallsStats"
        :key="client.id"
        @click="filterClientId(client.id)"
      >
        <div
          class="col col-3 id-col"
          v-if="!CheckUserPermission([7])"
          v-tooltip.top="{
            content: getSCStats(client).user.full_name
          }"
        >
          {{ getSCStats(client).user.first_name }}
        </div>

        <div class="col col-1 id-col">#{{ client.id }}</div>

        <div
          class="col col-3"
          v-tooltip.top="{
            content: client.full_name
          }"
        >
          {{ client.first_name | truncate(9) }}
        </div>

        <div
          class="col col-4"
          v-tooltip.top="{
            content: client.email_primary.contact_value
          }"
        >
          {{ client.email_primary.contact_value | truncate(10) }}
        </div>

        <div
          class="col col-4"
          v-tooltip.top="{
            content: getCountryStats(client.country_id).name
          }"
        >
          <img
            :src="
              `/img/flags/` +
                getCountryStats(client.country_id).alpha2.toLowerCase() +
                `.png`
            "
          />
        </div>

        <div
          class="col col-2"
          v-tooltip.top="{
            content: getSCStats(client).status.type
          }"
        >
          {{ getSCStats(client).status.type | truncate(15) }}
        </div>
        <div class="col col-2">
          {{ formatCallTime(getSCStats(client).scheduled_on) }}
        </div>
        <div class="col col-3">{{ getDiffInMin(getSCStats(client)) }} Min</div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment/moment";
import UsersPermissionCheck from "../../../../../../mixins/user/auth/UsersPermissionCheck";

export default {
  name: "NextCallsPopUp.component",
  mixins: [UsersPermissionCheck],
  props: {
    stats: {
      required: true,
      type: Array
    },
    show: {
      required: true,
      type: Boolean
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "nextCallsStats"])
  },
  methods: {
    sortNextCalls() {
      let arr = this.nextCallsStats;
      arr = arr.sort((a, b) => {
        if (this.getSCStats(a).scheduled_on < this.getSCStats(b).scheduled_on) {
          return -1;
        }
        if (this.getSCStats(a).scheduled_on > this.getSCStats(b).scheduled_on) {
          return 1;
        }
        return 0;
      });
      return arr;
    },
    getCountryStats(countryId) {
      return this.dictionaries.general.countries.find(
        country => country.id === countryId
      );
    },
    getSCStats(call) {
      return call.scheduled_calls[0];
    },
    formatCallTime(call) {
      return moment(call).format("H:mm");
    },
    getDiffInMin(call) {
      let fCall = moment(call.scheduled_on);
      return (
        moment(fCall).diff(moment(), "minutes") +
        `:${moment(fCall).diff(moment(), "seconds") % 60}`
      );
    },
    filterNextCalls() {
      this.$emit("filterNextCalls");
      this.$emit("closeNextCalls");
    },
    closeNextCalls() {
      this.$emit("closeNextCalls");
    },
    filterClientId(val) {
      this.$store.commit("clients/setFilterClientById", val);
    }
  }
};
</script>

<style scoped>
.btn:focus {
  outline: none;
}
.buttons-wrapper {
  display: flex;
  justify-content: space-between;
}
.container {
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 10px;
  padding-right: 10px;
}
.responsive-table {
  padding-left: 5px;
}
h2 {
  font-size: 13px;
  margin: 5px 0;
  text-align: center;
}
h2 small {
  font-size: 0.5em;
}

.responsive-table li {
  border-radius: 3px;
  padding: 25px 30px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}
.responsive-table .table-header {
  background-color: #e3ab59;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 5px;
  padding: 5px;
}
.responsive-table .table-row {
  background-color: #ffffff;
  box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  padding: 5px;
  font-size: 11px;
}
.responsive-table .col-1 {
  flex-basis: 15%;
}
.responsive-table .col-2 {
  flex-basis: 40%;
}
.responsive-table .col-3 {
  flex-basis: 36%;
}
.responsive-table .col-4 {
  flex-basis: 25%;
}
@media all and (max-width: 767px) {
  .responsive-table .table-header {
    display: none;
  }
  .responsive-table li {
    display: block;
  }
  .responsive-table .col {
    flex-basis: 100%;
  }
  .responsive-table .col {
    display: flex;
    padding: 10px 0;
  }
  .responsive-table .col:before {
    color: #6c7a89;
    padding-right: 10px;
    content: attr(data-label);
    flex-basis: 50%;
    text-align: right;
  }
}
.col {
  text-align: center;
}
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 2000; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  //background-color: rgba(184, 184, 184, 0.4); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  width: 60%;
  /*max-width: 700px;*/
}

/* Add Animation */
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }
  to {
    -webkit-transform: scale(1);
  }
}

@keyframes zoom {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-content {
    width: 100%;
  }
}

span.togglebutton {
  position: absolute;
  left: 0;
  top: 0;
  background-color: black;
  padding: 3px;
  color: white;
  font-size: 50px;
  z-index: 5555555555555555555555555555555555555555;
}
.table-row:hover {
  cursor: pointer;
  background-color: #e0e0e0;
}
.main-table {
  max-height: 180px;
  overflow-y: scroll;
}
</style>
